import { Alert, AlertDescription } from '@/components/ui/alert'
import { AuthShell } from '@/components/layouts/auth-shell'
import { GoogleSignInButton } from '@/components/features/auth/google-sign-in-button'
import { usePage } from '@inertiajs/react'
import { t } from "@/lib/i18n"
export default function AdminSignInIndex() {
    const { flash = {} } = usePage<{
        flash: {
            alert?: string
            notice?: string
        }
    }>().props
    return (<AuthShell title={t("ui.auth.titles.admin_sign_in")} headline={t("ui.auth.admin.headline")} blurb={t("ui.auth.admin.blurb")}>
      <div className="mb-8">
        <h1 className="text-2xl font-semibold tracking-tight">{t("ui.react.pages.admin.sign_in.index.welcome_new")}</h1>
        <p className="mt-1 text-sm text-muted-foreground">{t("ui.react.pages.admin.sign_in.index.sign_in_with_google_description")}</p>
      </div>

      <div className="grid gap-6">
        {flash.alert && (<Alert variant="destructive">
            <AlertDescription>{flash.alert}</AlertDescription>
          </Alert>)}
        <GoogleSignInButton label={t("ui.react.pages.admin.sign_in.index.continue_with_google")}/>
      </div>
    </AuthShell>)
}
